module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-finanzierung-circle-daed218b11ac7206d46ef5b5e1fd699c.svg";